import { useTranslation } from 'react-i18next';
import { Button, FormItem, Text } from '../Ant';
import { Flex } from 'antd';
import { Minus, Plus } from '../icons';
import { useWorkTime } from '../../context/WorkTimeContext';
import { useEffect, useState } from 'react';
import { getFormattedWorkTimeDuration } from '../../constants/workTime';
import dayjs from 'dayjs';
import { IWorkTime } from '../../interface/workTimes';

const AddDuration = () => {
  const { t } = useTranslation();
  const [subtractDisabled, setSubtractDisabled] = useState<boolean>(false);
  const { workTime, updateWorkTime } = useWorkTime();
  const { totalMinutes, formattedTime } = getFormattedWorkTimeDuration(
    dayjs(workTime?.startTime),
    dayjs(workTime?.endTime),
  );

  useEffect(() => {
    if (totalMinutes <= 0) {
      setSubtractDisabled(true);
    } else {
      setSubtractDisabled(false);
    }
  }, [totalMinutes]);

  const endAndStartTimeSelected = workTime?.startTime && workTime?.endTime;

  const handleTimeAddition = () => {
    const newEndTime = dayjs(workTime?.endTime).add(5, 'minutes').toISOString();
    updateWorkTime({ ...workTime, endTime: newEndTime } as unknown as IWorkTime);
  };

  const handleTimeSubtraction = () => {
    if (totalMinutes < 5) {
      const newEndTime = dayjs(workTime?.endTime).subtract(totalMinutes, 'minutes').toISOString();
      updateWorkTime({ ...workTime, endTime: newEndTime } as unknown as IWorkTime);
    } else {
      const newEndTime = dayjs(workTime?.endTime).subtract(5, 'minutes').toISOString();
      updateWorkTime({ ...workTime, endTime: newEndTime } as unknown as IWorkTime);
    }
  };

  return (
    <FormItem className="w-full" label={t('worktime:duration')} data-testid="worktime-duration">
      <Flex gap={16} align="center">
        <Button
          data-testid="subtract-duration-button"
          aria-label={t('common:timers.removeFiveMinutes')}
          type="primary"
          maxwidth="34px"
          height="34px"
          radius="8px"
          disabled={subtractDisabled}
          onClick={handleTimeSubtraction}
        >
          <Minus className="fs-18 flex-shrink-0" />
        </Button>
        <Text
          data-testid="worktime-duration-text"
          aria-live="polite"
          $fontsize="13px"
          $lineheight="20px"
          $color="description"
        >
          {formattedTime}
        </Text>
        <Button
          data-testid="add-duration-button"
          aria-label={t('common:timers.addFiveMinutes')}
          type="primary"
          maxwidth="34px"
          height="34px"
          radius="8px"
          disabled={!endAndStartTimeSelected}
          onClick={handleTimeAddition}
        >
          <Plus className="fs-18 flex-shrink-0" />
        </Button>
      </Flex>
    </FormItem>
  );
};

export default AddDuration;
